export default function ImpactSection() {
  const impacts = [
    {
      number: '12명',
      label: '봉제 기술 인력',
      icon: 'ri-user-star-line',
    },
    {
      number: '40+',
      label: '지역 봉제 네트워크',
      icon: 'ri-links-line',
    },
    {
      number: '100%',
      label: '지속가능 소재 활용',
      icon: 'ri-leaf-line',
    },
  ];

  return (
    <section className="py-28 bg-emerald-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-emerald-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-700 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-5" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Daygreen Impact
          </h2>
          <p className="text-lg text-emerald-100">
            숫자로 보는 우리의 성장
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {impacts.map((impact, index) => (
            <div key={index} className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full mx-auto mb-6">
                <i className={`${impact.icon} text-4xl text-emerald-300`}></i>
              </div>
              <div className="text-5xl md:text-6xl font-bold text-white mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                {impact.number}
              </div>
              <div className="text-lg text-emerald-100">
                {impact.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}